import React from "react";
import ErrorPage from "../Notification/Error";

function ForgotPage({ props }) {
  const { loading, onChange, onSubmit, isError } = props;
  return (
    <div className="verification overflow-x-hidden ">
      <div className="ver-box py-12 w-4/5 lg:w-2/5">
        <div name="header " className="w-full text-center ">
          <p className="header-title-bold ver-title m-0 font-bold text-2xl lg:text-3xl">
            Lupa Password
          </p>
          <div className="flex w-full justify-center">
            <p className="header-title-semi ver-subtitle mt-2 w-4/5 font-semibold lg:text-sm lg:w-96 ">
              Silahkan masukkan email anda untuk pengiriman link reset password
            </p>
          </div>
        </div>

        <div
          name="email-form"
          className="w-full my-5 mb-10 flex px-5 justify-center"
        >
          <div className="w-72 lg:w-96">
            <p className="login-title-form mb-3 text-xl lg:text-2xl">Email</p>
            <input
              onChange={(e) => onChange(e)}
              disabled={loading}
              className={`${
                loading ? "input-disabled" : "form-input"
              } outline-none w-full p-3 lg:p-4`}
              placeholder="Masukkan email anda"
            />
            {isError
              ? isError.length > 0
                ? isError
                    .filter((it) => it.type === "email")
                    .map((its, idx) => (
                      <ErrorPage
                        key={idx}
                        props={{ idx, message: its.message }}
                      />
                    ))
                : null
              : null}
          </div>
        </div>

        <div
          name="button home"
          className="w-full px-5 flex justify-center mt-5"
        >
          <button
            disabled={loading}
            onClick={onSubmit}
            className={`${
              loading ? "btn-loading" : "btn-blue"
            } w-60 lg:w-96 p-3 focus:outline-none`}
          >
            <p className="text-white font-semibold lg:text-lg">
              {loading ? "Loading" : "Send Link"}
            </p>
          </button>
        </div>
      </div>
    </div>
  );
}

export default ForgotPage;
